export const leanColums = [
  {
    name: "Nome do aluno",
    value: "user_name",
    completeValue: "user_name",
    filter: true,
  },
  {
    name: "Email",
    value: "user_email",
    completeValue: "user_email",
    filter: false,
  },
  {
    name: "Rótulo",
    value: "checked",
    completeValue: "checked",
    filter: false,
  },
];

export const engageOptions = [
  { name: "Não avaliado", value: 0 },
  { name: "Correto", value: 1 },
  { name: "Incorreto", value: 2 },
];

export const studentInfo = (row: any) => {
  return Object.freeze([
    { name: "Nome do Usuário", value: row.user_name },
    { name: "Email do Usuário", value: row.user_email },
    { name: "Curso", value: row.course_name },
  ]);
};

export const courseInfo = (row: any) => {
  return Object.freeze([
    {
      name: "Objetivos concluídos",
      value: row.done,
      subtitle: row.shap_done,
    },
    {
      name: "Média do Quiz",
      value: `${Number(row.meanQuiz).toFixed(1)}%`,
      subtitle: row.shap_meanQuiz,
    },
    {
      name: "Materiais Curtidos",
      value: row.quantityLikedMaterials,
      subtitle: row.shap_quantityLikedMaterials,
    },
    {
      name: "Materiais Pulados",
      value: row.quantitySkippedMaterials,
      subtitle: row.shap_quantitySkippedMaterials,
    },
    { name: "Perda de atenção", value: row.quantityLostAttention },
    {
      name: "Atenção Habilitada",
      value: row.attention_enabled === 1 ? "Sim" : "Não",
    },
    {
      name: "Delta de Tempo",
      value: `${Math.floor(row.averageTimeDelta / 3600)}h ${Math.floor(
        (row.averageTimeDelta % 3600) / 60
      )}m`,
      subtitle: row.shap_averageTimeDelta,
    },
    {
      name: "Quiz Reprovado",
      value: row.failedQuiz,
      subtitle: row.shap_failedQuiz,
    },
    {
      name: "Total de matérias do curso",
      value:
        row.total_quantity_of_materials_in_the_course === 1
          ? `${row.total_quantity_of_materials_in_the_course} matéria`
          : `${row.total_quantity_of_materials_in_the_course} matérias`,
    },
    {
      name: "Duração total do curso",
      value: `${Math.floor(row.averageTimeDelta / 3600)}h ${Math.floor(
        (row.averageTimeDelta % 3600) / 60
      )}m`,
      subtitle: row.shap_total_quantity_of_duration_in_the_course,
    },
  ]);
};

export const mathInfo = (row: any) => {
  return Object.freeze([
    { name: "NPS", value: row.nps, subtitle: row.shap_nps },
    {
      name: "Taxas Médias",
      value: `${Number(row.meanRates).toFixed(2)}`,
      subtitle: row.shap_meanRates,
    },
    {
      name: "Fora do padrão",
      value: `${Number(row.meanRates).toFixed(2)}`,
      subtitle: row.shap_outOfPattern,
    },
    { name: "Inclinação", value: `${Number(row.slope).toFixed(2)}` },
  ]);
};
export const checkedInfo = (row: any) => {
  return Object.freeze([{ name: "Rótulo", value: row.checked }]);
};

export const STATUS_MAP: Record<number, string> = Object.freeze({
  0: "Não avaliado",
  1: "Correto",
  2: "Incorreto",
});

export function getStatusText(value: number): string {
  return STATUS_MAP[value] || "Desconhecido";
}
